import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=a7249c20&scoped=true&"
import script from "./PropertyDetail.vue?vue&type=script&lang=js&"
export * from "./PropertyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&id=a7249c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7249c20",
  null
  
)

component.options.__file = "PropertyDetail.vue"
export default component.exports